// extracted by mini-css-extract-plugin
export default {"errorMessage":"styles_errorMessage__vfEYA"};